import { Box, CircularProgress } from '@mui/material';
import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Loader } from '@/components/loader';
import { AuthContext, ConferenceContext } from '@/store';
import { UserMonitorContextProvider } from '@/user-monitor';
import { AuthWall } from '@/js/shared/components/AuthWall';
import { liveWelcomeRoutes, liveRoutes } from './LiveRoutes.config';
import {
  wrapWithProviders,
  resolveRouteProps,
} from '@/routes/config/route-config.types';
import { LIVE } from '@/routes/config/paths';

export const LiveRoutes = () => {
  const { authState } = useContext(AuthContext);
  const { conferenceState, welcomeState } = useContext(ConferenceContext);

  const buildElement = (route, extraProps = {}) => {
    const resolvedProps = {
      ...resolveRouteProps(route.props),
      ...extraProps,
    };
    return wrapWithProviders(
      route.providers,
      React.createElement(route.Component, resolvedProps)
    );
  };

  const routesToRender = welcomeState ? liveWelcomeRoutes : liveRoutes;

  return authState.stateLoaded && conferenceState.conferenceDetail ? (
    <UserMonitorContextProvider>
      <Router>
        <AuthWall>
          <React.Suspense fallback={<Loader />}>
            <Routes>
              {routesToRender.map((route) => (
                <Route
                  key={route.path === '*' ? 'fallback' : route.path}
                  path={route.path}
                  element={buildElement(
                    route,
                    route.path === LIVE.ROOM ? { user: authState.user } : {}
                  )}
                />
              ))}
            </Routes>
          </React.Suspense>
        </AuthWall>
      </Router>
    </UserMonitorContextProvider>
  ) : (
    <Box align="center">
      <CircularProgress disableShrink />
    </Box>
  );
};
